export default __webpack_public_path__ + "static/media/formas-digitales-fondo-banner-1.d370b01c.png";